class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.activeParams = this.$stateParams;
    this.Events = $injector.get("Events");
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.paginateEvent = this.Events.getPaginateEvent("countries");
    this.filterEvent = this.Events.getFilterEvent("countries");
    this.sortEvent = this.Events.getSortEvent("countries");
    this.sections = Sections.settingsSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/countries/countries.controller.js